import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import Icon from 'molecules/Icon';

import { FlexibleComparisonCellProps } from 'components/Tables/FeatureComparisonTable/config';

interface FlexibleTableCellProps extends Partial<FlexibleComparisonCellProps> {
  alignEnd?: boolean;
}

// Icons are SVG-only, so screen readers and LLMs reading the HTML see an empty cell (and shift the
// next cell's text into it). This text is visually hidden and only rendered when the icon has no visible text.
const iconText: Record<string, string> = { check: 'Yes', 'x-mark': 'No', warning: 'Partial' };

const FlexibleTableCellIcon: FC<Pick<FlexibleTableCellProps, 'icon'>> = ({ icon }) => {
  switch (icon) {
    case 'check':
      return <Icon icon="circle-check-1" size={25} iconColor="text-primary-300" />;
    case 'x-mark':
      return <Icon icon="x-circle" size={25} iconColor="text-gray-500" />;
    case 'warning':
      return <Icon icon="warning" size={25} iconColor="text-gray-500" />;
    default:
      return null;
  }
};

const FlexibleTableCell: FC<FlexibleTableCellProps> = ({ icon, text, alignEnd }) => (
  <div className={twJoin('flex w-full items-center gap-2.5', alignEnd ? 'justify-end text-right' : 'justify-start')}>
    {icon && icon !== 'none' && (
      <span className="flex shrink-0">
        <FlexibleTableCellIcon icon={icon} />
      </span>
    )}
    {!text && icon && iconText[icon] && <span className="sr-only">{iconText[icon]}</span>}
    {text && <span className="text-sm font-medium leading-5 text-gray-300 md:text-lg md:leading-7">{text}</span>}
  </div>
);

export default FlexibleTableCell;
